import { render } from "./browserListSupported.vue?vue&type=template&id=554b01d4&scoped=true&ts=true"
import script from "./browserListSupported.ts?vue&type=script&lang=ts"
export * from "./browserListSupported.ts?vue&type=script&lang=ts"

import "./browserListSupported.scss?vue&type=style&index=0&id=554b01d4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554b01d4"]])

export default __exports__